// Multimarca B2B2C: MBM entrega la plataforma a entidades que la usan con SU marca.
// Marcas ficticias (nunca entidades reales). MBM por defecto.
// La marca activa es GLOBAL: se persiste y aplica a home, wizard, casos, sitio y corredor.
import { useEffect, useState } from 'react';

export const MARCAS = {
  mbm: { id: 'mbm', nombre: 'MBM', color: '#E40C0C', mono: 'M' },
  andino: { id: 'andino', nombre: 'Banco Andino', color: '#1E3A8A', mono: 'A' },
  solidaria: { id: 'solidaria', nombre: 'Caja Solidaria', color: '#0F766E', mono: 'C' },
  horizonte: { id: 'horizonte', nombre: 'Horizonte Corredores', color: '#C2410C', mono: 'H' },
};

export const MARCA_DEFAULT = 'mbm';
const KEY = 'mbm:marca';

// Lee la marca desde el hash: soporta "#sitio&marca-andino" o "#corredor&marca-solidaria".
export function marcaFromHash(hash = window.location.hash) {
  return MARCAS[getMarcaIdActiva(hash)];
}

export function getMarcaIdActiva(hash = (typeof window !== 'undefined' ? window.location.hash : '')) {
  const m = /marca-([a-z]+)/i.exec(hash || '');
  if (m && MARCAS[m[1].toLowerCase()]) return m[1].toLowerCase();
  try {
    const s = localStorage.getItem(KEY);
    if (s && MARCAS[s]) return s;
  } catch (e) { /* noop */ }
  return MARCA_DEFAULT;
}

export function getMarcaActiva() {
  return MARCAS[getMarcaIdActiva()];
}

// Aplica la marca como variable CSS global + data-attr en <html>.
export function applyMarcaCss(id = getMarcaIdActiva()) {
  const m = MARCAS[id] || MARCAS[MARCA_DEFAULT];
  if (typeof document !== 'undefined') {
    document.documentElement.style.setProperty('--marca', m.color);
    document.documentElement.dataset.marca = m.id;
    document.title = `${m.nombre} · Cuéntanos qué está cambiando en tu vida`;
  }
}

export function setMarcaActiva(id) {
  const real = MARCAS[id] ? id : MARCA_DEFAULT;
  try { localStorage.setItem(KEY, real); } catch (e) { /* noop */ }
  applyMarcaCss(real);
  if (typeof window !== 'undefined') window.dispatchEvent(new Event('mbm:marca'));
}

// Hook: marca activa reactiva a cambios (selector, hashchange, otra vista).
export function useMarca() {
  const [, force] = useState(0);
  useEffect(() => {
    applyMarcaCss();
    const on = () => force((v) => v + 1);
    window.addEventListener('mbm:marca', on);
    window.addEventListener('hashchange', on);
    return () => {
      window.removeEventListener('mbm:marca', on);
      window.removeEventListener('hashchange', on);
    };
  }, []);
  return [getMarcaActiva(), setMarcaActiva];
}

// Reescribe el hash conservando la vista (#sitio / #corredor) y cambiando la marca.
export function hashConMarca(vista, marcaId) {
  return marcaId && marcaId !== MARCA_DEFAULT ? `#${vista}&marca-${marcaId}` : `#${vista}`;
}

export function vistaFromHash(hash = window.location.hash) {
  if ((hash || '').startsWith('#corredor')) return 'corredor';
  return 'sitio';
}
